/* eslint-disable no-use-before-define */
export function usePrivacytoString(detail) {
    const documentContent = detail?.documentContent?.dpaDetailDocument;
    let date = '';
    if (detail?.requiredInformation?.updateDate) {
        const split = detail?.requiredInformation?.updateDate.split('/');
        const year = split[2].split(' ');
        date = `_${split[0]}-${split[1]}-${year[0]}_`;
    }
    return {
        html: `<html>
        <head>
        <meta charset="UTF-8" />
        <title>Document</title>
        <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js"></script>
        <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
    </head>
    <body style="word-break: break-word;">
            ${documentContent}
            <script type="text/javascript">
            $(document).ready(function() {
            let allElements = $('*');
            let converted = htmlDocx.asBlob(allElements.html());
            saveAs(converted, '${
                detail?.requiredInformation?.dpaName + `${date}TH.docx`
            }');
            setTimeout(()=> window.close(), 100)
            });</script>
        </body>
    </html>`,
    };
}
